import React, { useState } from 'react'
import TextField from '@mui/material/TextField'

export type FormKeyFieldProp = {
  disabled: boolean
  maxBytes?: number
  value: string
  label?: String
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  fullWidth?: boolean
}

const FormKeyField: React.FC<FormKeyFieldProp> = ({
  value,
  maxBytes = 40,
  label = 'Key',
  fullWidth = false,
  onChange,
  disabled = false,
}) => {
  const encoder = new TextEncoder()
  const [keyValue, setKeyValue] = useState(value)
  const [byteCount, setByteCount] = useState(encoder.encode(value).length)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const text = event.target.value
    const bytes = encoder.encode(text)

    if (bytes.length <= maxBytes) {
      setKeyValue(text)
      setByteCount(bytes.length)
      onChange(event)
    } else {
      const trimmed = new TextDecoder().decode(bytes.slice(0, maxBytes)).replace(/\uFFFD$/g, '')

      setKeyValue(trimmed)
      setByteCount(maxBytes)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: 300 }}>
      <TextField
        label={label}
        variant="outlined"
        value={keyValue}
        onChange={handleChange}
        inputProps={{ style: { fontFamily: 'monospace' } }}
        helperText={`${byteCount} / ${maxBytes}`}
        fullWidth={fullWidth}
        disabled={disabled}
      />
    </div>
  )
}

export default FormKeyField
